/** The width of the left bar that holds the list of workspaces */
export const WORKSPACE_NAV_WIDTH = 60;

/** The width of the part of the side nav that collapses which holds the boards nav and navigation */
export const CURRENT_WORKSPACE_NAV_WIDTH = 272;
